export enum DscEnsure {
    Absent = 0,
    Present = 1
}
